/**
 * Accessibilité de la navigation de l'en-tête.
 *
 * - Garde `aria-expanded` synchronisé sur les menus déroulants et le bouton du menu mobile.
 * - Ferme un menu déroulant ouvert avec Échap et remet le focus sur son bouton.
 * - Nomme la navigation du menu mobile.
 *
 * Le thème garde la main sur l'ouverture : ce fichier ne fait que refléter l'état.
 */

const syncDropdownToggle = (component) => {
  const toggle = component.querySelector('[data-ref="dropdown-toggle"]');
  if (!toggle) return;

  toggle.setAttribute('aria-expanded', component.getAttribute('data-open') === 'true' ? 'true' : 'false');
};

const initDropdowns = (root) => {
  root.querySelectorAll('dropdown-component').forEach((component) => {
    if (component.dataset.a11yReady === 'true') return;

    const toggle = component.querySelector('[data-ref="dropdown-toggle"]');
    if (!toggle) return;

    component.dataset.a11yReady = 'true';
    toggle.setAttribute('aria-haspopup', 'true');
    syncDropdownToggle(component);

    new MutationObserver(() => syncDropdownToggle(component)).observe(component, {
      attributes: true,
      attributeFilter: ['data-open'],
    });
  });
};

const closeDropdown = (component) => {
  if (typeof component.close === 'function') {
    component.close();
    return;
  }

  component.setAttribute('data-open', 'false');
  syncDropdownToggle(component);
};

const initMobileMenuState = () => {
  const header = document.querySelector('header-component');
  if (!header) return;

  const toggle = header.querySelector('[data-ref="menu-toggle"]');
  const overlay = header.querySelector('[data-ref="mobile-menu-overlay"]');
  if (!toggle || !overlay) return;

  const navLabel = header.dataset.navLabelMobile;
  const drawerNav = overlay.querySelector('.header__mobile-menu-nav');
  if (navLabel && drawerNav && !drawerNav.hasAttribute('aria-label')) {
    drawerNav.setAttribute('aria-label', navLabel);
  }

  const sync = () => {
    const isOpen = overlay.classList.contains('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    overlay.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
  };

  sync();
  new MutationObserver(sync).observe(overlay, { attributes: true, attributeFilter: ['class'] });
};

const init = () => {
  initDropdowns(document);
  initMobileMenuState();
};

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  const openDropdown = document.querySelector('dropdown-component[data-open="true"]');
  if (!openDropdown) return;

  const toggle = openDropdown.querySelector('[data-ref="dropdown-toggle"]');
  closeDropdown(openDropdown);
  toggle?.focus();
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}

document.addEventListener('shopify:section:load', init);
